var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computedFn } from 'mobx-utils';
import { memoize } from '../utils/mobx/decorators/memoize';
import { RegistryCategory } from './RegistryCategory';
import { runtime } from '../classes/runtime/Runtime';
import { inPackage } from '../packages/package_resolve';
export class RegistryRoof extends RegistryCategory {
    registryType;
    isRoof = true;
    rawRegistryItems = {};
    initializedRegs = new Map();
    get categories() {
        if (this.registryType === 'event')
            return super.categories;
        return [
            ...super.categories,
            ...this.parent.runtime.availablePackages.allAvailablePackages.map(p => p.availablePackage[`${this.registryType}s`]),
        ].filter(c => !!c);
    }
    resolveWhenAvailable = computedFn((key) => {
        const refreshOnNewPackage = runtime.availablePackages.allAvailablePackages;
        if (inPackage[this.registryType] && inPackage[this.registryType][key]) {
            const x = runtime.streamedPackages[inPackage[this.registryType][key]];
        }
        const packageName = key.split('_')[0];
        if (['Plugin', 'Exotic', 'Lazy', 'Rare', 'Grundschule', 'Layout', 'Draft'].includes(packageName)) {
            const x = runtime.streamedPackages[packageName];
        }
        // console.log('resolve reg key WhenAvailable', key, this);
        return this.rawRegistryItems[key];
    });
    getRegByKey(key) {
        const memoized = this.initializedRegs.get(key);
        if (memoized)
            return memoized;
        let reg = this.rawRegistryItems[key];
        if (!reg && !['aspectfilter', 'actorfilter'].includes(this.registryType)) {
            reg = this.resolveWhenAvailable(key);
        }
        if (!reg)
            return undefined;
        if (typeof reg === 'function') {
            reg = reg();
        }
        reg.key = key;
        if (this.registryType === 'trait' && this.c_css.cssKeys.includes(key)) {
            this.c_css.addScaleAndTransition(reg);
        }
        this.initializedRegs.set(key, reg);
        return reg;
    }
    get registry_object() {
        return new Proxy({}, {
            get: (target, key) => {
                const reg = this.getRegByKey(key);
                if (!reg) {
                    console.log(`Kein ${this.constructor.name} Eintrag für`, key);
                }
                return reg;
            },
        });
    }
}
__decorate([
    memoize
], RegistryRoof.prototype, "registry_object", null);
